const verification = require('@/utils/verification'),
  { getCodeText } = require('@/api/user')

module.exports = {
  data() {
    return {
      countTimeNumber: 60,
      countTimer: -1,

      phoneValue: '',
      codeValue: '',
      passValue: '',
    }
  },
  computed: {
    // 禁止验证码点击
    isDisableCode() {
      return this.countTimer == -1 ? false : true
    },
    // 验证码文本
    codeText() {
      let countTimer = this.countTimer
      return countTimer > 0 ? this.countTimeNumber + 's后' : '发送验证码'
    },
  },
  created() {
    // 引入js
    var script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute(
      'src',
      'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/public_resources/TCaptcha/TCaptcha.js'
    )
    document.getElementsByTagName('head')[0].appendChild(script)
  },
  methods: {
    // 获取验证码
    getCode(type) {
      if (this.isDisableCode) return

      let verifyPhoneResult = this.verifyPhoneValue()
      if (!verifyPhoneResult.result) {
        this.$toast(verifyPhoneResult.msg)
        return
      }

      let data = this.routeFixedParam({
        phone: verifyPhoneResult.value,
        type: type ? type : 'login',
      })

      //生成一个滑块验证码对象
      var captcha = new TencentCaptcha('2064328247', (res) => {
        if (res.ret === 0) {
          // 页面上滑动正确，请求自己的业务接口
          // 记得把验证成功的票据和随机字符带到自己接口中去腾讯验证票据的真实性
          console.log()
          this.checkTencentCode(res.ticket, res.randstr, data.type, data.phone)
        }
      })
      captcha.langFun()
      // 滑块显示
      captcha.show()

      // getCodeText(data).then(() => {
      //     this.openCodeTimer()
      // })
    },
    // 验图形验证码且发送短信
    async checkTencentCode(ticket, randstr, smsType, phone) {
      const params = this.routeFixedParam({
        ticket: ticket,
        randstr: randstr,
        phone: phone,
        type: smsType,
      })
      const respose = await getCodeText(params).catch((err) => console.log(err))

      const resposeData = respose?.data || null
      // if (!resposeData) {
      //     showToast("图形验证码异常");
      //     return;
      // }
      this.openCodeTimer()
    },
    // 开启验证码倒计时
    openCodeTimer() {
      this.countTimer = setInterval(() => {
        if (this.countTimeNumber < 1) {
          clearInterval(this.countTimer)
          this.countTimeNumber = 60
          this.countTimer = -1
        }
        this.countTimeNumber--
      }, 1000)
    },

    // 验证手机号
    verifyPhoneValue() {
      let phoneValue = this.phoneValue,
        result = verification.verifyPhone(phoneValue)
      return result
    },
    // 验证密码
    verifyPasswordValue() {
      let passValue = this.passValue,
        result = verification.verifyPassword(passValue)

      return result
    },
    // 验证验证码
    verifyCodeValue() {
      let codeValue = this.codeValue,
        result = verification.verifyCode(codeValue)
      return result
    },
  },
}
